import { fetchFromAPI } from '@/Utils/stripeHooks/helpers';
import { useQuery } from 'react-query';

export type BillingHistoryItem = {
  date: string;
  description?: string;
  amount: number;
  id: string;
  invoice_url: string;
  status: string;
  invoice_lines: InvoiceLines[];
  use_invoice_lines: boolean;
};
export type InvoiceLines = {
  amount: string;
  currency: string;
  description: string;
  id: string;
  type: string;
};

const fetchBillingHistory = async (): Promise<BillingHistoryItem[]> => {
  const data = await fetchFromAPI<{ billing_history: BillingHistoryItem[] }>(
    '/api/v1/billing_history',
  );
  return data.billing_history || [];
};

export const usePaymentHistory = () => {
  return useQuery({
    queryKey: ['billingHistory'],
    queryFn: fetchBillingHistory,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 0,
  });
};
